import { render, staticRenderFns } from "./RapidAccessFinalGradeReviews.vue?vue&type=template&id=a256559a&scoped=true&"
import script from "./RapidAccessFinalGradeReviews.vue?vue&type=script&lang=js&"
export * from "./RapidAccessFinalGradeReviews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a256559a",
  null
  
)

export default component.exports